<template>
		<div class="nav">
			<transition name="slide">
				<div class="nav-content container-fluid"  v-bind:key="toggled" :class="{'nav-mobile-hidden': toggled}">
          <div class="row">
            <div class="nav-part-1 col-sm-12" :class="{'scrolled': scrolled}">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-lg-5 nav-contact-info">
                    <b-nav>
                      <b-nav-item href="tel:+48570870699"><font-awesome-icon icon="phone" /><span>+48 570-870-699</span></b-nav-item>
                      <b-nav-item href="mailto:veki@veki.pl"><font-awesome-icon icon="envelope" /><span>veki@veki.pl</span></b-nav-item>
                    </b-nav>
                  </div>
                  <div class="d-none d-lg-flex col-lg-7 nav-others">
                    <b-nav>
                      <b-nav-item><font-awesome-icon icon="users" /><router-link to="/moje-konto"><span>{{ $t('nav.myAccount') }}</span></router-link></b-nav-item>
                      <b-nav-item><font-awesome-icon icon="envelope" /><router-link to="/kontakt"><span>{{ $t('nav.contact') }}</span></router-link></b-nav-item>
                    </b-nav>
                    <b-nav class="nav-tight">
                      <b-nav-item><img class="nav-flag" src="/wp-content/themes/veki-wp/imgs/flags/en.png" title="English" @click="changeLang('en')"></b-nav-item>
                      <b-nav-item><img class="nav-flag" src="/wp-content/themes/veki-wp/imgs/flags/fr.png" title="French" @click="changeLang('fr')"></b-nav-item>
                      <b-nav-item><img class="nav-flag" src="/wp-content/themes/veki-wp/imgs/flags/de.png" title="German" @click="changeLang('de')"></b-nav-item>
                      <b-nav-item><img class="nav-flag" src="/wp-content/themes/veki-wp/imgs/flags/it.png" title="Italian" @click="changeLang('it')"></b-nav-item>
                      <b-nav-item><img class="nav-flag" src="/wp-content/themes/veki-wp/imgs/flags/pl.png" title="Polish" @click="changeLang('pl')"></b-nav-item>
                    </b-nav>
                  </div>
                </div>
              </div>
            </div>
            <div class="nav-part-2 col-sm-12" :class="{'scrolled': scrolled}">
              <b-nav>
                  <b-nav-item>
                    <router-link to="/"><img class="nav-logo" src="/wp-content/themes/veki-wp/imgs/veki-logo-web.svg"></router-link>
                  </b-nav-item>
                  <b-nav-item-dropdown :text="$t('nav.firstStep')" extra-toggle-classes="nav-link-custom" right>
                    <b-dropdown-item><router-link to="/witaj-na-naszej-stronie">{{ $t('nav.navigate') }} <font-awesome-icon :icon="['fas', 'book']"/></router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/dlaczego-veki">{{ $t('nav.whyUs') }} <font-awesome-icon :icon="['fas', 'lightbulb']"/></router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/galeria">{{ $t('nav.nice') }} <font-awesome-icon :icon="['far', 'smile']"/></router-link></b-dropdown-item>
                  </b-nav-item-dropdown>
                  <b-nav-item-dropdown :text="$t('nav.shop')" extra-toggle-classes="nav-link-custom" right>
                    <b-dropdown-item><router-link to="/sklep">{{ $t('nav.shopAll') }}</router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/pojemniki"><img class="nav-product" src="/wp-content/themes/veki-wp/imgs/products/pojemnik.png" :alt="$t('nav.shopContainers')"> {{ $t('nav.shopContainers') }}</router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/rynienki"><img class="nav-product" src="/wp-content/themes/veki-wp/imgs/products/rynienka.png" :alt="$t('nav.shopLarvals')"> {{ $t('nav.shopLarvals') }}</router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/organizery"><img class="nav-product" src="/wp-content/themes/veki-wp/imgs/products/organizery.png" :alt="$t('nav.shopOrganizers')"> {{ $t('nav.shopOrganizers') }}</router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/pudelka"><img class="nav-product" src="/wp-content/themes/veki-wp/imgs/products/pudelko.png" :alt="$t('nav.shopBoxes')"> {{ $t('nav.shopBoxes') }}</router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/product-category/zestawy"><img class="nav-product" src="/wp-content/themes/veki-wp/imgs/products/zestaw.png" :alt="$t('nav.shopCategoryKits')"> {{ $t('nav.shopCategoryKits') }}</router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/product-category/etykiety"><img class="nav-product" src="/wp-content/themes/veki-wp/imgs/products/etykieta.png" :alt="$t('nav.shopCategoryLabels')"> {{ $t('nav.shopCategoryLabels') }}</router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/product-category/vouchery"><img class="nav-product" src="/wp-content/themes/veki-wp/imgs/products/voucher.png" :alt="$t('nav.shopCategoryVouchers')"> {{ $t('nav.shopCategoryVouchers') }}</router-link></b-dropdown-item>
                  </b-nav-item-dropdown>
                  <b-nav-item-dropdown :text="$t('nav.organizeDrawer')" extra-toggle-classes="nav-link-custom" right>
                    <b-dropdown-item><router-link to="/szuflada">{{ $t('nav.genDimensions') }} <font-awesome-icon icon="envelope" /></router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/konfigurator">{{ $t('nav.genDesign') }} <font-awesome-icon :icon="['fas', 'th']"/></router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/galeria">{{ $t('nav.materials') }} <font-awesome-icon :icon="['fas', 'palette']"/></router-link></b-dropdown-item>
                  </b-nav-item-dropdown>
                  <b-nav-item><router-link to="/inspiracje">{{ $t('nav.blog') }}</router-link></b-nav-item>
                  <b-nav-item><router-link to="/koszyk"><font-awesome-icon :icon="['fas', 'shopping-cart']"/> {{ cart.subTotal }} zł</router-link></b-nav-item>
                </b-nav>
            </div>
          </div>
        </div>
			</transition>
      <!-- <div class="update-warning" v-if="showUpdateWarning === 'true'">
        <p class="mb-0 pr-3"><b>Sklep Veki.pl jest w trakcie aktualizacji, pewne moduły nie będa aktywne do jej zakończenia.</b></p> <button class="btn btn-sm btn-outline-dark uppercase" @click="toggleUpdateWarning"><b>ok</b></button>
      </div> -->
			<div class="nav-toggle" @click="toggle"><font-awesome-icon icon="bars" /></div>
		</div>
</template>

<script>
export default {
	name: 'Navigation',
  props: {
    nav: Array,
  },
	data () {
		return {
      showUpdateWarning: this.$cookies.get('update_warning') !== null ? this.$cookies.get('update_warning') : 'true',
      cart: {
        total: '0,00',
        subTotal: '0,00',
        shippingTotal: '0,00',
        discount: 0,
      },
      scrolled: false,
      toggled: true
		}
	},
  mounted() {
    this.fetchCart();
    window.addEventListener('scroll', this.handleScroll);
    this.$parent.$moment.locale(this.$parent.$store.getters.lang === '' ? 'pl' : this.$parent.$store.getters.lang);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
	methods: {
    toggleUpdateWarning() {
      this.$cookies.set('update_warning', 'false');
      this.showUpdateWarning = 'false';
    },
    fetchCart() {
      return new Promise((resolve, reject)  => {
        this.$api.cartCalculate().then(() => {
          resolve(this.$api.fetchCartTotal().then((data) => {
            if (data.total > 0) {
              this.cart.total = data.total.replace('.',',');
              this.cart.subTotal = data.subtotal.replace('.',',');
              this.cart.shippingTotal = data.shipping_total.replace('.',',');
              this.cart.discount = data.discount_total;
            }
            resolve(true);
          }))
        })
      })
    },
    clearCart() {
      this.cart.total = '0,00';
      this.cart.subTotal = '0,00';
      this.cart.shippingTotal = '0,00';
      this.$api.cartCalculate().then(() => {
        return;
      })
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    },
		toggle() {
			this.toggled = !this.toggled;
		},
    scrollTop() {
      const top = document.getElementById('app').offsetTop;
      window.scrollTo({
        top: top - 66,
        behavior: "smooth"
      });
    },
    changeLang(lang) {
      this.$store.dispatch('changeLanguage', lang);
      this.$i18n.locale = lang;
      this.lang = lang;
      this.$parent.$moment.locale(lang);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~$scss/components/nav";
</style>